<template>
  <div class="position">
    <a-modal
      class="modal"
      :visible="visible"
      v-bind="$attrs"
      v-on="$listeners"
      :closable="false"
      :maskClosable="false"
      :footer="null"
    >
      <div class="modal_header p-20">
        <h4>
          <span class="modal_title">评价</span>
        </h4>
        <img @click="close" :src="closeImg" alt="" />
        <!-- <a-icon type="close" @click="close" /> -->
      </div>
      <div class="eva-question">您对本堂课满意吗</div>
      <div class="margin-top">
        <div v-for="(item, index) in evaluateList" :key="index">
          <div class="flex align-center ml20">
            <div class="eva-label">{{ item.starTitle }}</div>
            <!-- <a-rate v-model="value" /> -->
            <a-rate
              :default-value="opinionValue"
              v-model="item.starNum"
              style="font-size: 16px"
              @change="getRate(item, index)"
            />
            <div v-for="(label, idx) in item.labelConfList" :key="idx">
              <div class="eva-hint" v-if="item.starNum === label.star">
                {{ item.starNum === label.star ? label.label : '' }}
              </div>
            </div>
          </div>
        </div>
        <div class="evaluate-tab">
          <span v-for="(item, index) in evaluateList" :key="index" class="">
            <span
              v-for="(tag, tagIndex) in item.tagConfList"
              :key="tagIndex"
              @click="getEvaluate(index, tag, tagIndex)"
            >
              <span class="evaluate-hint" :class="{ active: tag.check }" v-if="getTag(tag, item)">
                {{ tag.title }}
              </span>
            </span>
          </span>
        </div>
      </div>
      <div class="eva-textarea">
        <a-input v-model="content" placeholder="写下你的想法…" type="textarea" :rows="6" class="ask-textarea" />
      </div>
      <div class="ask-bask">
        <!-- <div @click="goShowImage()"><img src="../img/img-icon.png" class="icon-play" /></div> -->
        <a-button :loading="loading" class="btn_right" type="primary" @click="submit">评价 </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import closeImg from '@/assets/icons/close.png'
export default {
  name: '',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    scheduleId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      closeImg,
      content: '',
      opinionValue: 5, // 评价等级
      tabIndex: 0,
      rules: {
        content: [{ required: true, message: '提问内容不能为空', trigger: 'blur' }],
      },
      evaluateList: [],
    }
  },
  watch: {
    visible(val) {
      this.evaluateList = []
      this.content = ''
      if (val) {
        document.querySelector('body').setAttribute('style', 'overflow: hidden')
      } else {
        document.querySelector('body').setAttribute('style', 'overflow: auto')
       }
      this.initData()
    },
  },
  components: {},
  created() {
    this.initData()
  },
  computed: {
    coverFileList() {
      let arr = []
      if (this.form.photos) {
        arr = [this.form.photos]
      }
      return arr
    },
  },
  methods: {
    async initData() {
      const res = await this.$http.get(`/b/classes/biz/scheduleAppraise/conf`)
      this.evaluateList = res.startConfList
      for (const it of res.startConfList) {
        for (const item of it.tagConfList) {
          item.check = false
          // item.pId = it.id
        }
      }
      // console.log('res', res, this.tabList)
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    getEvaluate(index, tag, tagIndex) {
      // this.evaluateList[index].check = !tag.check
      // console.log('this.evaluateList', this.evaluateList)
      this.evaluateList[index].tagConfList[tagIndex].check = !tag.check
      // console.log('this.evaluateList', this.evaluateList)
      this.$forceUpdate()
      //  this.tabIndex = index
    },
    async submit() {
      // console.log('this.evaluateList', this.evaluateList)
      const stars = this.evaluateList.reduce((result, value) => {
        // console.log('value.starNum', value.starNum)
        if (!value.starNum) {
          return result
        }
        const tags = value.tagConfList.filter((i) => i.check).map((i) => ({ starTagConfId: i.id, title: i.title }))
        result.push({
          starId: value.id,
          stars: value.starNum,
          tags,
        })
        return result
      }, [])
      // console.log('stars', stars)
      if (stars?.length !== this.evaluateList?.length) {
        this.$message.error('请对课程进行评分')
        return
      }
      await this.$http.post(`/b/classes/biz/studentScheduleAppraise/v2/pc/raise`, {
        content: this.content,
        scheduleId: this.scheduleId,
        stars,
      })
      this.$message.success('提交成功')
      this.$emit('refresh')
      this.close()
    },
    getTag(tag, item) {
      // console.log('tag', tag, starNum)
      if (item.starNum && tag.starBegin <= item.starNum && tag.starEnd >= item.starNum) {
        return true
      } else {
        return false
      }
    },
    getRate(item, index) {
      // console.log('456', item, index)
      for (const item of this.evaluateList[index].tagConfList) {
        item.check = false
        // item.pId = it.id
      }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-modal-content {
  border-radius: 15px;
}
/deep/.ant-modal-body {
  padding: 0;
}
.p-12 {
  padding: 12px;
}
.border {
  border-top: 1px solid #ced3dc;
  border-bottom: 1px solid #ced3dc;
}
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin: -24px;
  // padding: 12px;
  // padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  .modal_title {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    position: absolute;
    top: 15px;
    left: 48%;
  }
  img {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }
}
.upload_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin: -24px;
  // padding: 12px;
  // padding-bottom: 12px;
  .upload_title {
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: #333;
  }
  img {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }
}
.ant-form {
  margin-top: 16px;
  .ant-input {
    background: #f5f6fa;
    border-radius: 15px;
    border: none;
  }
}
.p-20 {
  padding: 20px;
}
.ask-textarea {
  // background: #f5f6fa;
  border-radius: 5px;
  border: none;
  border: 1px solid #dcdcdc;
}
.ask-bask {
  padding: 0 20px 20px;
  display: flex;
  justify-content: center;
}
.btn_right {
  width: 200px;
  background: #4b7dfd;
}
.eva-question {
  font-size: 16px;
  color: #303133;
  font-weight: bold;
  padding: 20px 20px 0 20px;
}
.align-center {
  align-items: center;
}
.eva-label {
  margin-right: 10px;
}
.ml20 {
  margin-left: 20px;
  margin-bottom: 10px;
}
.eva-textarea {
  padding: 10px 20px 20px 20px;
}
.flex {
  display: flex;
}
.margin-top {
  margin-top: 20px;
}
.evaluate-tab {
  margin: 0 20px;
  flex-wrap: wrap;
}
.evaluate-hint {
  padding: 5px 8px;
  text-align: center;
  color: #333;
  margin: 0 10px 10px 0;
  background: #eaecf1;
  border-radius: 4px;
  display: inline-block;
  cursor: pointer;
}
.evaluate-hint.active {
  color: #fff;
  background-color: #4b7dfd;
}
.eva-hint {
  margin-left: 20px;
}
</style>
